(() => {
  const article = document.querySelector('[data-gift-article]');
  const content = article?.querySelector('[data-gift-content]');
  if (!content) return;

  const productArrow = article.querySelector('[data-gift-product-arrow]');

  const categoryIds = new Map([
    ['for work', 'gift-article-work'],
    ['for travel', 'gift-article-travel'],
    ['for the pocket', 'gift-article-pocket'],
    ['for everyday carry', 'gift-article-everyday'],
  ]);
  const original = Array.from(content.children);
  const headings = original.filter((node) => node.tagName === 'H2');
  if (![...categoryIds.keys()].every((label) => headings.some((node) => node.textContent.trim().toLowerCase() === label))) return;

  let current;
  for (const node of original) {
    if (node.tagName === 'H2') {
      const label = node.textContent.trim().toLowerCase();
      current = document.createElement('section');
      current.className = 'nw-gift-article__chapter';
      if (categoryIds.has(label)) {
        current.classList.add('nw-gift-article__category');
        current.id = categoryIds.get(label);
        current.tabIndex = -1;
      } else if (label === 'start with what he uses') {
        current.classList.add('nw-gift-article__chooser');
      } else if (label === 'questions before you buy') {
        current.classList.add('nw-gift-article__questions');
      } else if (label === 'why nordweg') {
        current.classList.add('nw-gift-article__closing');
      }
      content.append(current);
    }
    if (!current) {
      current = document.createElement('div');
      current.className = 'nw-gift-article__opening';
      content.append(current);
    }
    current.append(node);
  }

  const preface = document.createElement('div');
  preface.className = 'nw-gift-article__preface';
  const opening = content.querySelector('.nw-gift-article__opening');
  const chooser = content.querySelector('.nw-gift-article__chooser');
  content.prepend(preface);
  if (opening) preface.append(opening);
  if (chooser) preface.append(chooser);

  // Optical framing is tied to these exact source files; replacement photos fall back safely.
  const productFraming = {
  "nordweg-slim-workplace-leather-laptop-backpack-caramel-angled-front-view-sku-nw108-ca-gtin-7898571002072.jpg": [1.1467, 2.5, -1.528, 1.0669],
  "nordweg-workplace-leather-desk-pad-caramel-desk-setup-laptop-mouse-glasses-sku-nwa07-ca-gtin-7898571001327.jpg": [
    1.094,
    0.278,
    -0.833,
    1.0669
  ],
  "nordweg-nomad-leather-laptop-backpack-black-back-padded-straps-sku-nw089a-ip-gtin-7898571000917.jpg": [
    1.0355,
    0.417,
    -1.389,
    1.0669
  ],
  "nordweg-dolomites-leather-travel-backpack-coffee-side-padded-back-shoulder-straps-sku-nw101-ic-gtin-7898571001037.jpg": [
    0.9987,
    1.111,
    -3.472,
    1.0669
  ],
  "nordweg-workplace-leather-tech-organizer-cable-case-black-closed-top-view-sku-nwa05-ip-gtin-7898571001273.jpg": [
    1.2094,
    0.417,
    -3.611,
    1.0669
  ],
  "nordweg-dolomites-leather-weekender-travel-bag-coffee-side-handles-sku-nw103-ic-gtin-7898571001068.jpg": [
    1.1217,
    0.139,
    0.278,
    1.0669
  ],
  "nordweg-nomad-leather-passport-wallet-travel-document-holder-black-open-card-slots-passport-pocket-sku-nw087-ip-gtin-7898571000887.jpg": [
    1.0151,
    0.278,
    0.833,
    1.0669
  ],
  "nordweg-ledger-leather-bifold-wallet-coffee-open-plaid-id-window-card-slots-sku-nw038a-ic-xa-gtin-7898571000160.jpg": [
    1.2741,
    0.278,
    -0.556,
    1.0669
  ],
  "nordweg-marco-leather-airtag-wallet-cardholder-coffee-open-plaid-interior-card-slots-sku-nw041i-ic-xa-gtin-7898571000320.jpg": [
    1.2484,
    -0.417,
    0.833,
    1.0669
  ],
  "nordweg-nomad-leather-crossbody-bag-black-studio-angled-back-pocket-view-sku-nw091a-ip-gtin-7898571000962.webp": [
    1.1552,
    5.139,
    -0.972,
    1.0669
  ],
  "nordweg-flint-leather-cardholder-wallet-black-back-view-cards-cash-sku-nw109-ip-gtin-7898571001235.jpg": [
    1.3579,
    7.639,
    -1.25,
    1.0669
  ],
  "nordweg-pulse-leather-sling-crossbody-bag-black-front-zip-pocket-sku-nw112-ip-gtin-7898571002256.jpg": [
    0.9187,
    -0.278,
    -3.194,
    1.0669
  ],
  "nordweg-flint-leather-cardholder-wallet-black-front-plaid-id-window-sku-nw109-ip-gtin-7898571001235.png": [
    1.4535,
    -0.278,
    -0.694,
    1.0669
  ]
,

    "nordweg-dolomites-leather-travel-backpack-coffee-front-flap-buckles-sku-nw101-ic-gtin-7898571001037.jpg": [1.1057, -0.278, -1.389, 1.068],
    "nordweg-nomad-leather-crossbody-bag-black-studio-front-zip-pocket-view-sku-nw091a-ip-gtin-7898571000962.webp": [0.9556, -0.278, -4.167, 1.068],
    "nordweg-slim-workplace-laptop-backpack-caramel-primary-2500_339bd11e-cc9f-43b6-bdc9-d1f34fc39c38.jpg": [
        0.9556,
        -0.139,
        0.0
    ],
    "nordweg-nomad-laptop-backpack-black-merchant-feed-2500_30291cff-376a-4dcf-98bb-1388a9227bcd.jpg": [
        1.0567,
        0.0,
        0.417
    ],
    "nordweg-workplace-desk-pad-caramel-primary-2500_829262c7-0243-4541-8388-76590fb1939e.jpg": [
        0.9615,
        0.278,
        0.139
    ],
    "nordweg-workplace-tech-organizer-black-merchant-feed-2500_8b58c5fe-67b6-4b61-bbba-1b9b4fcc6a97.jpg": [
        0.9797,
        0.0,
        0.139
    ],
    "nordweg-dolomites-weekender-coffee-merchant-feed-2500_cfc1aa72-5754-4255-8845-f32ef57f4bb3.jpg": [
        1.0531,
        0.0,
        0.0
    ],
    "nordweg-nomad-passport-wallet-black-primary-2500_ad48fbb7-cb35-4cfa-8643-862a40c9c1e4.jpg": [
        0.9705,
        -0.556,
        0.694
    ],
    "nordweg-dolomites-travel-backpack-coffee-merchant-feed-2500.jpg": [
        1.0151,
        0.0,
        1.806
    ],
    "nordweg-flint-cardholder-coffee-merchant-feed-2500.jpg": [
        1.0603,
        0.278,
        2.083
    ],
    "nordweg-traveler-pro-airtag-wallet-caramel-primary-2500_484c5343-e55b-48c6-8cf3-92c0762ea6db.jpg": [
        0.9556,
        -0.833,
        0.0
    ],
    "nordweg-marco-airtag-wallet-coffee-merchant-feed-2500_b446dc8e-eb8a-490b-ada1-3200bba177ec.jpg": [
        1.1299,
        2.778,
        0.972
    ],
    "nordweg-ledger-wallet-coffee-primary-2500_6876990c-cc92-4ebf-bc73-119d33305dc9.jpg": [
        0.9891,
        -0.139,
        1.111
    ],
    "nordweg-pulse-leather-sling-bag-black-primary-2500_04e5b6c3-e228-4cb0-8c63-4f6916ca20fe.jpg": [
        0.9556,
        0.0,
        0.833
    ],
    "nordweg-nomad-leather-crossbody-sling-bag-caramel-front-zipper-pocket-strap-sku-nw091a-ca.jpg": [
        0.9585,
        -2.639,
        -3.056
    ]
};

  const photoVariants = {
    "41527775133784": "41527775133784",
    "41527804199000": "41527804133464",
    "41527838343256": "41527838376024",
    "41527916789848": "41527916789848",
    "41574361333848": "41574361366616",
    "41574077825112": "41574077857880",
    "41564697100376": "41564697100376",
    "43061352530008": "43061352562776",
    "41564579758168": "41564579790936",
    "41527900995672": "41527901061208",
    "41527822286936": "41527822254168",
    "44269924221016": "44269924221016",
    "41564763684952": "41564763684952"
};

  // Alternate views are verified PDP images of the same selected color.
  const productAlternates = {
  "slim-workplace-laptop-backpack": {
    "url": "https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-slim-workplace-laptop-backpack-caramel-back-panel-stitching-detail-nw108-ca.jpg?v=1790719598",
    "altText": "Nordweg Slim Workplace Laptop Backpack in Caramel, close-up of the padded mesh back panel and stitching.",
    "width": 2000,
    "height": 2000,
    "variant": "41527775133784",
    "primary": {
      "url": "https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-slim-workplace-laptop-backpack-caramel-side-view-nw108-ca.jpg?v=1790719592",
      "altText": "Nordweg Slim Workplace Laptop Backpack in Caramel, side view with zipper and shoulder strap.",
      "width": 2500,
      "height": 2500
    }
  },
  "nomad-laptop-backpack": {
    "url": "https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-nomad-leather-laptop-backpack-black-side-profile-shoulder-straps-sku-nw089a-ip-gtin-7898571000917.jpg?v=1782772966",
    "altText": "Nordweg Nomad leather laptop backpack in black, side profile with shoulder straps",
    "width": 800,
    "height": 800,
    "variant": "41527804133464",
    "primary": {
      "url": "https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-nomad-leather-laptop-backpack-black-with-removable-laptop-sleeve-sku-nw089a-ip-gtin-7898571000917.jpg?v=1782772694",
      "altText": "Black Nordweg Nomad leather laptop backpack shown with matching removable laptop sleeve",
      "width": 800,
      "height": 800
    }
  },
  "workplace-desk-pad": {
    "url": "https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-workplace-leather-desk-pad-caramel-logo-edge-detail-sku-nwa07-ca-gtin-7898571001327.jpg?v=1782772997",
    "altText": "Close-up of caramel Workplace leather desk pad edge with Nordweg logo",
    "width": 800,
    "height": 800,
    "variant": "41527838376024",
    "primary": {
      "url": "https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-workplace-leather-desk-pad-caramel-rolled-view-strap-sku-nwa07-ca-gtin-7898571001327.jpg?v=1782772966",
      "altText": "Nordweg Workplace leather desk pad in caramel, rolled view with strap",
      "width": 800,
      "height": 800
    }
  },
  "workplace-tech-organizer": {
    "url": "https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-workplace-tech-organizer-black-zipper-pull-detail-nwa05-ip.jpg?v=1790720510",
    "altText": "Nordweg Workplace Tech Organizer in Black, close-up of the zipper pull and rounded closure edge.",
    "width": 1500,
    "height": 1500,
    "variant": "41527916789848",
    "primary": {
      "url": "https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-workplace-tech-organizer-black-closed-top-view-nwa05-ip-source-20260929.jpg?v=1790720505",
      "altText": "Nordweg Workplace Tech Organizer in Black, closed top view with the embossed Nordweg wordmark.",
      "width": 2500,
      "height": 2500
    }
  },
  "dolomites-travel-backpack": {
    "url": "https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-dolomites-leather-travel-backpack-black-side-padded-back-shoulder-straps-sku-nw101-ip-gtin-7898571001020.jpg?v=1782774062",
    "altText": "Nordweg Dolomites leather travel backpack in black, side view with padded back and shoulder straps",
    "width": 800,
    "height": 800,
    "variant": "41574361333848",
    "primary": {
      "url": "https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-dolomites-leather-travel-backpack-black-front-flap-buckles-sku-nw101-ip-gtin-7898571001020.jpg?v=1782774062",
      "altText": "Nordweg Dolomites leather travel backpack in black, front view with flap and metal buckles",
      "width": 800,
      "height": 800
    }
  },
  "dolomites-weekender": {
    "url": "https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-dolomites-weekender-black-front-buckle-strap-detail.jpg?v=1785187695",
    "altText": "Close-up of the front buckle and shoulder strap on the Nordweg Dolomites Weekender in Black.",
    "width": 2000,
    "height": 1999,
    "variant": "41574077825112",
    "primary": {
      "url": "https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-dolomites-leather-weekender-travel-bag-black-front-shoulder-strap-sku-nw103-ip-gtin-7898571001051.jpg?v=1782770905",
      "altText": "Nordweg Dolomites leather weekender travel bag in black, front view with shoulder strap",
      "width": 800,
      "height": 800
    }
  },
  "nomad-passport-wallet": {
    "url": "https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-nomad-leather-passport-wallet-travel-document-holder-caramel-back-view-sku-nw087-ca-gtin-7898571000900.jpg?v=1782773410",
    "altText": "Nordweg Nomad leather passport wallet in caramel, back view",
    "width": 800,
    "height": 800,
    "variant": "41564697165912",
    "primary": {
      "url": "https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-nomad-leather-passport-wallet-travel-document-holder-caramel-open-card-slots-passport-pocket-sku-nw087-ca-gtin-7898571000900.jpg?v=1782773410",
      "altText": "Open caramel Nomad leather passport wallet showing card slots and passport pocket",
      "width": 800,
      "height": 800
    }
  },
  "traveler-pro-airtag-wallet": {
    "variant": "43061352562776",
    "primary": {
      "url": "https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-traveler-pro-airtag-leather-wallet-caramel-mini-cardholder-cards-in-hand-sku-nw111-ca-gtin-7898571002195.jpg?v=1782774341",
      "altText": "Caramel Traveler Pro AirTag wallet mini cardholder shown in hand with cards",
      "width": 1000,
      "height": 1000
    }
  },
  "flint-cardholder": {
    "url": "https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-flint-leather-cardholder-wallet-black-payment-detail-cash-pocket-in-hand-sku-nw109-ip-gtin-7898571001235.jpg?v=1783732925",
    "altText": "Black Nordweg Flint leather cardholder wallet held open with cash in the pocket",
    "width": 800,
    "height": 800,
    "variant": "41564579758168",
    "primary": {
      "url": "https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-flint-leather-cardholder-wallet-black-angled-view-loaded-with-cards-sku-nw109-ip-gtin-7898571001235.jpg?v=1782772339",
      "altText": "Angled black Nordweg Flint leather cardholder loaded with cards",
      "width": 1000,
      "height": 1000
    }
  },
  "ledger-wallet": {
    "url": "https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-ledger-bifold-wallet-coffee-id-window-plaid-detail.jpg?v=1790718186",
    "altText": "Nordweg Ledger Bifold Wallet in Coffee, close-up of the ID window and stitched plaid lining.",
    "width": 1500,
    "height": 1500,
    "variant": "41527901061208",
    "primary": {
      "url": "https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-ledger-bifold-wallet-coffee-back-source-20260929.jpg?v=1790718138",
      "altText": "Nordweg Ledger Bifold Wallet in Coffee, closed back view with perimeter stitching.",
      "width": 2500,
      "height": 2500
    }
  },
  "marco-airtag-wallet": {
    "variant": "41527822254168",
    "primary": {
      "url": "https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-marco-leather-airtag-wallet-cardholder-coffee-back-card-pocket-sku-nw041i-ic-xa-gtin-7898571000320.jpg?v=1782771852",
      "altText": "Nordweg Marco leather AirTag wallet cardholder in coffee, back view with card pocket",
      "width": 1000,
      "height": 1000
    }
  },
  "pulse-leather-sling-bag": {
    "url": "https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-pulse-leather-sling-crossbody-bag-black-rear-pocket-card-storage-sku-nw112-ip-gtin-7898571002256.jpg?v=1782774633",
    "altText": "Black Pulse leather sling crossbody bag with rear pocket shown holding a card",
    "width": 1000,
    "height": 1000,
    "variant": "44269924221016",
    "primary": {
      "url": "https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-pulse-leather-sling-crossbody-bag-black-angled-front-strap-key-tag-sku-nw112-ip-gtin-7898571002256.jpg?v=1782774633",
      "altText": "Nordweg Pulse leather sling crossbody bag in black, angled front view with strap and key tag",
      "width": 1000,
      "height": 1000
    }
  },
  "nomad-crossbody-bag": {
    "url": "https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-nomad-crossbody-bag-coffee-exterior-zipper-detail-nw091a-ic.jpg?v=1790721979",
    "altText": "Nordweg Nomad Crossbody Bag in Coffee, close-up of the exterior zipper, pull, and surrounding stitching.",
    "width": 1500,
    "height": 1500,
    "variant": "41564763750488",
    "primary": {
      "url": "https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-nomad-leather-crossbody-bag-coffee-studio-front-zip-pocket-view-sku-nw091a-ic-gtin-7898571000986.webp?v=1783732936",
      "altText": "Nordweg Nomad Crossbody Bag in Coffee, front view with its exterior zip pocket and leather strap.",
      "width": 2500,
      "height": 2500
    }
  }
};
  const resizeImage = (img) => {
    img.removeAttribute('style');
    try {
      const url = new URL(img.getAttribute('src'), window.location.href);
      const framing = productFraming[decodeURIComponent(url.pathname.split('/').pop())];
      if (framing) {
        img.style.setProperty('--product-scale', framing[0]);
        img.style.setProperty('--product-brightness', framing[3] || 1);
        img.style.setProperty('--product-x', `${framing[1]}%`);
        img.style.setProperty('--product-y', `${framing[2]}%`);
      }
      const sized = (width) => {
        const copy = new URL(url);
        copy.searchParams.set('width', String(width));
        return copy.toString();
      };
      img.srcset = [176, 224, 336].map((width) => `${sized(width)} ${width}w`).join(', ');
      img.sizes = '(min-width: 990px) 112px, 88px';
      img.src = sized(336);
    } catch (_) {
      // Retain the original image if its URL cannot be resized.
    }
  };

  Array.from(content.querySelectorAll('.nw-gift-article__category')).forEach((category, chapterIndex) => {
    const heading = category.querySelector('h2');
    const groups = [];
    let group;
    for (const node of Array.from(category.children).slice(1)) {
      if (node.querySelector('img')) { group = []; groups.push(group); }
      if (group) group.push(node);
    }
    if (!groups.length) return;
    const scene = article.querySelector(`[data-gift-scene="${category.id}"]`);
    if (scene) {
      category.append(scene.content.cloneNode(true));
    } else {
      category.classList.add('nw-gift-article__category--without-scene');
    }
    const panel = document.createElement('div');
    panel.className = 'nw-gift-chapter__panel';
    const number = document.createElement('span');
    number.className = 'nw-gift-chapter__number';
    number.textContent = `${String(chapterIndex + 1).padStart(2, '0')} / 04`;
    const chapterHeader = document.createElement('header');
    chapterHeader.className = 'nw-gift-chapter__header';
    chapterHeader.append(number, heading);
    category.prepend(chapterHeader);

    groups.forEach((nodes) => {
      const imageNode = nodes[0];
      const images = Array.from(imageNode.querySelectorAll('img'));
      const titleNode = nodes.find((node) => node.tagName === 'P' && node.querySelector('a[href*="/products/"]'));
      const links = titleNode ? Array.from(titleNode.querySelectorAll('a[href*="/products/"]')) : [];
      if (!links.length) return;
      const subtitle = Array.from(titleNode.childNodes)
        .filter((child) => !links.includes(child)).map((child) => child.textContent)
        .join('').replace(/^\s*:\s*/, '').trim();
      links.forEach((link, imageIndex) => {
        const item = document.createElement('div');
        item.className = 'nw-gift-product';
        if (links.length > 1) item.classList.add('nw-gift-product--paired');
        const image = images[imageIndex];
        const destination = new URL(link.href);
        const alternate = productAlternates[destination.pathname.split('/').pop()];
        const photoVariant = alternate?.variant || photoVariants[destination.searchParams.get('variant')];
        if (photoVariant) {
          destination.searchParams.set('variant', photoVariant);
          link.href = destination.toString();
        }
        const media = document.createElement('a');
        media.className = 'nw-gift-product__media';
        media.href = link.href;
        media.setAttribute('aria-label', link.textContent.trim());
        if (image) {
          if (link.href.includes('/nomad-crossbody-bag')) {
            image.src = article.dataset.crossbodyImage || image.src;
            image.alt = 'Nordweg Nomad Crossbody Bag in Black, full front view';
          }
          if (link.href.includes('/dolomites-travel-backpack')) {
            image.src = 'https://cdn.shopify.com/s/files/1/0651/0667/files/nordweg-dolomites-leather-travel-backpack-coffee-front-flap-buckles-sku-nw101-ic-gtin-7898571001037.jpg?v=1782774062';
            image.alt = 'Nordweg Dolomites Travel Backpack in Coffee, full front view';
          }
          if (alternate?.primary) {
            image.src = alternate.primary.url;
            image.alt = alternate.primary.altText;
          }
          resizeImage(image);
          image.className = 'nw-gift-product__primary';
          media.append(image);
          if (alternate?.url) {
            const second = document.createElement('img');
            second.className = 'nw-gift-product__alternate';
            second.alt = '';
            second.setAttribute('aria-hidden', 'true');
            second.width = alternate.width;
            second.height = alternate.height;
            second.loading = 'lazy';
            second.decoding = 'async';
            second.addEventListener('load', () => media.classList.add('nw-gift-product__media--ready'), { once: true });
            second.src = alternate.url;
            resizeImage(second);
            media.append(second);
            if (second.complete && second.naturalWidth) media.classList.add('nw-gift-product__media--ready');
          }
        }
        const copy = document.createElement('div');
        copy.className = 'nw-gift-product__copy';
        const title = document.createElement('h3');
        title.textContent = link.textContent.trim();
        copy.append(title);
        if (links.length === 1) {
          if (subtitle) {
            const deck = document.createElement('p');
            deck.className = 'nw-gift-product__deck';
            deck.textContent = subtitle;
            copy.append(deck);
          }
          nodes.slice(1).forEach((node) => { if (node !== titleNode) copy.append(node); });
        } else {
          // Mack's shared description applies to both products; repeat it verbatim.
          nodes.slice(1).forEach((node) => { if (node !== titleNode) copy.append(node.cloneNode(true)); });
        }
        link.className = 'nw-gift-product__link';
        link.setAttribute('aria-label', `View ${title.textContent}`);
        link.textContent = 'View product';
        if (productArrow) link.append(productArrow.content.cloneNode(true));
        copy.append(link);
        item.append(media, copy);
        panel.append(item);
      });
      if (links.length > 1) nodes.slice(1).forEach((node) => { if (node !== titleNode) node.remove(); });
      imageNode.remove();
      titleNode.remove();
    });
    category.append(panel);
  });
  // Keep the two closing sections on the same text axes as the preface and chapters.
  content.querySelectorAll('.nw-gift-article__questions, .nw-gift-article__closing').forEach((section) => {
    const body = document.createElement('div');
    body.className = 'nw-gift-article__section-body';
    Array.from(section.children).filter((node) => node.tagName !== 'H2').forEach((node) => body.append(node));
    section.append(body);
  });
  content.querySelectorAll('p').forEach((p) => { if (!p.textContent.trim() && !p.querySelector('img')) p.remove(); });
  content.classList.add('nw-gift-article__content--enhanced');
  const navigation = article.querySelector('[data-gift-navigation]');
  if (navigation) navigation.hidden = false;
})();
